module.exports = __webpack_public_path__ + "img/logo.f683a428.png";